import * as firebase from 'firebase/app';
import 'firebase/firestore';
import { NOTIFICATIONS } from 'utils/constants/collectionNames';
import { NOTIFICATIONS_LIMIT } from 'utils/constants/notifications';
import {
  GET_NOTIFICATIONS_SUCCEEDED,
  GET_NOTIFICATIONS_ERROR,
  LOADING_STATE,
  GET_MORE_NOTIFICATIONS_SUCCEEDED,
  GET_MORE_NOTIFICATIONS_ERROR,
  GET_UNREAD_NOTIFICATIONS_COUNT_SUCCEEDED,
  GET_UNREAD_NOTIFICATIONS_COUNT_ERROR
} from './types';

// fetch notifications from Firebase
export const getNotifications = trainerId => async dispatch => {
  try {
    let firestore = firebase.firestore();
    let queryRef = firestore
      .collection(NOTIFICATIONS)
      .where('trainer_id', '==', trainerId)
      .orderBy('created_at', 'desc')
      .limit(NOTIFICATIONS_LIMIT);

    dispatch({
      type: LOADING_STATE
    });

    queryRef.onSnapshot(querySnapshot => {
      const events =
        querySnapshot.docs &&
        querySnapshot.docs.map(doc => {
          return { ...doc.data(), id: doc.id };
        });

      dispatch({
        type: GET_NOTIFICATIONS_SUCCEEDED,
        payload: {
          events,
          lastVisible: querySnapshot.docs[querySnapshot.docs.length - 1],
          hasMore: events.length === NOTIFICATIONS_LIMIT
        }
      });
    });
  } catch (err) {
    console.log(err);
    dispatch({
      type: GET_NOTIFICATIONS_ERROR,
      payload: `error: ${err}`
    });
  }
};

// get more notifications from Firebase
export const getMoreNotifications = (
  trainerId,
  lastVisible
) => async dispatch => {
  let firestore = firebase.firestore();
  let queryRef = firestore
    .collection(NOTIFICATIONS)
    .where('trainer_id', '==', trainerId)
    .orderBy('created_at', 'desc')
    .startAfter(lastVisible)
    .limit(NOTIFICATIONS_LIMIT);

  queryRef
    .get()
    .then(res => {
      const events =
        res.docs &&
        res.docs.map(doc => {
          return { ...doc.data(), id: doc.id };
        });

      dispatch({
        type: GET_MORE_NOTIFICATIONS_SUCCEEDED,
        payload: {
          events,
          lastVisible: res.docs[res.docs.length - 1],
          hasMore: events.length === NOTIFICATIONS_LIMIT
        }
      });
    })
    .catch(err => {
      console.log(err);
      dispatch({
        type: GET_MORE_NOTIFICATIONS_ERROR,
        payload: `error: ${err}`
      });
    });
};

// get unread notifications from Firebase
export const getUnreadNotificationsCount = (
  trainerId,
  lastReadDate
) => async dispatch => {
  try {
    let firestore = firebase.firestore();
    let queryRef = firestore
      .collection(NOTIFICATIONS)
      .where('trainer_id', '==', trainerId)
      .where('created_at', '>', lastReadDate);

    queryRef.onSnapshot(querySnapshot => {
      dispatch({
        type: GET_UNREAD_NOTIFICATIONS_COUNT_SUCCEEDED,
        payload: querySnapshot.docs.length
      });
    });
  } catch (err) {
    console.log(err);
    dispatch({
      type: GET_UNREAD_NOTIFICATIONS_COUNT_ERROR,
      payload: `error: ${err}`
    });
  }
};
